import { CheckCircle2 } from "lucide-react";
import { withDefaults } from "@/lib/sections";
import { SectionShell, SectionHeading } from "./shared";

export const CardsSection = ({ id, content }) => {
  const c = withDefaults("cards", content);
  return (
    <SectionShell id={`s-${id}`} testId={`custom-section-${id}`}>
      <SectionHeading eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {(c.items || []).map((it, i) => (
          <div key={i} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-transform duration-300 hover:-translate-y-1">
            <CheckCircle2 className="h-6 w-6 text-orange-500" />
            <h3 className="mt-4 text-lg font-semibold text-white">{it.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{it.description}</p>
          </div>
        ))}
      </div>
    </SectionShell>
  );
};

export default CardsSection;
